import * as AppointmentActions from './AppointmentActions.js';

const initialState = {
  isLoadingWaitList: false,
  waitList: [],
  blockages: null,
  estimations: null,
  appointments: [],
  clientEstimations: [],
  staffEstimations: [],
  staffEstimationsLoading: false,
  bookings: null,
};

export default function appointment(state = initialState, action) {
  switch (action.type) {
    case 'UNAUTHORIZED':
      return {
        ...initialState,
      };
    case 'LOGOUT':
      return {
        ...initialState,
      };
    case AppointmentActions.LOADING_WAIT_LIST:
      return {
        ...state,
        isLoadingWaitList: true,
      };
    case AppointmentActions.LOAD_WAIT_LIST:
      return {
        ...state,
        isLoadingWaitList: false,
        waitList: action.data.appointments.sort(
          (a1, a2) => a1.remaining_time - a2.remaining_time
        ),
      };
    case AppointmentActions.LOAD_ESTIMATIONS:
      return {
        ...state,
        estimations: action.data.estimations,
      };
    case AppointmentActions.CLEAR_ESTIMATIONS:
      return {
        ...state,
        estimations: null,
      };
    case AppointmentActions.LOAD_CLIENT_ESTIMATIONS:
      return {
        ...state,
        clientEstimations: action.data.estimations,
      };
    case AppointmentActions.CLEAR_CLIENT_ESTIMATIONS:
      return {
        ...state,
        clientEstimations: [],
      };

    case AppointmentActions.LOAD_STAFF_ESTIMATIONS:
      return {
        ...state,
        staffEstimations: action.data.estimations,
        staffEstimationsLoading: false,
      };
    case AppointmentActions.CLEAR_STAFF_ESTIMATIONS:
      return {
        ...state,
        staffEstimations: [],
      };
    case AppointmentActions.SET_STAFF_ESTIMATIONS_LOADING:
      return {
        ...state,
        staffEstimationsLoading: true,
      };

    case AppointmentActions.LOAD_BLOCKAGES:
      return {
        ...state,
        blockages: action.data.blockages,
      };
    case AppointmentActions.SET_APPOINTMENTS:
      return {
        ...state,
        appointments: [
          ...state.appointments,
          {
            ...action.data.appointment
          }
        ],
      };
    case AppointmentActions.CLEAR_APPOINTMENTS:
      return {
        ...state,
        appointments: [],
      };
    case AppointmentActions.CLEAR_BOOKINGS:
      return {
        ...state,
        bookings: null,
      };
    case AppointmentActions.LOAD_BOOKINGS:
      return {
        ...state,
        bookings: action.data,
      };
    default:
      return state;
  }
}
